

































































import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import RenameDialog from '@c/RenameDialog.vue';
import {Can} from '@casl/vue';
import {TrendTaskTableHeader} from './interfaces';
import trendtaskStoreModule from '@/store/modules/trendtaskModule';
import {
  pmoduleDataRoutesByTypeMap,
  pmoduleDeveloperInfoDataRoutesByTypeMap,
} from '@v/system/modules/configurate';

@Component({
  components: {
    TableRoute,
    RenameDialog,
    Can,
  },
})
export default class TrendTasks extends Vue {
  headers: TrendTaskTableHeader[] = [
    {
      text: 'Название',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Описание',
      value: 'description',
      sortable: false,
    },
    {
      text: 'Датчик',
      value: 'module_name',
      sortable: false,
    },
  ];

  get apiStore() {
    return trendtaskStoreModule;
  }

  get renameDialog() {
    return this.$refs.renameDialog as any;
  }

  rename(item: any) {
    const clone_item = {...item};
    this.renameDialog.open(clone_item, {
      saveCallback: async (data: any) => {
        try {
          await this.apiStore.save(data);
          this.renameDialog.close();
          await this.apiStore.fetchAll();
        } catch (e) {
          this.renameDialog.error('Произошла ошибка');
        }
      },
    });
  }

  showDeveloperModuleInfo(item: any) {
    const {href} = this.$router.resolve({
      name: pmoduleDeveloperInfoDataRoutesByTypeMap.get(item.type),
      params: {id: `${item.id}`},
    });
    window.open(href, '_blank');
  }

  showModuleView(item: any) {
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(item.type),
      params: {id: `${item.id}`},
    });
    window.open(href, '_blank');
  }
}
